import React from "react";

interface ModalProps {
    isOpen: boolean;
    onClose?: () => void;
    children: React.ReactNode;
    showCloseButton?: boolean;
    className?: string;
}

export const Modal: React.FC<ModalProps> = ({
    isOpen,
    onClose,
    children,
    showCloseButton = true,
    className = "",
}) => {
    if (!isOpen) return null;

    const overlayStyle: React.CSSProperties = {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
    };

    const modalStyle: React.CSSProperties = {
        backgroundColor: "white",
        padding: "32px",
        borderRadius: "8px",
        textAlign: "center",
        maxWidth: "500px",
        maxHeight: "80vh",
        overflow: "auto",
        margin: "20px",
        position: "relative",
    };

    const closeButtonStyle: React.CSSProperties = {
        position: "absolute",
        top: "12px",
        right: "12px",
        background: "none",
        border: "none",
        fontSize: "24px",
        cursor: "pointer",
        color: "#6b7280",
        padding: "4px",
        lineHeight: 1,
    };

    return (
        <div
            style={overlayStyle}
            onClick={(e) => {
                if (e.target === e.currentTarget && onClose) {
                    onClose();
                }
            }}
        >
            <div style={modalStyle} className={className}>
                {showCloseButton && onClose && (
                    <button
                        style={closeButtonStyle}
                        onClick={onClose}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.color = "#374151";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.color = "#6b7280";
                        }}
                    >
                        ×
                    </button>
                )}
                {children}
            </div>
        </div>
    );
};
